import {
  componentCodeOf,
  formulaStatus,
  isVariablePayrollComponent,
  overlayOvertimeFromExtraWork,
} from "./salaryComponentModel";

function prepareComponentRows(list, extraWork = null) {
  const raw = Array.isArray(list) ? list : [];
  const hasOvertime = raw.some((r) => componentCodeOf(r) === "OVERTIME" && r.is_active !== false);
  const withoutDuplicateOt = raw.filter((r) => !(hasOvertime && componentCodeOf(r) === "OT"));
  return withoutDuplicateOt.map((r) => overlayOvertimeFromExtraWork(r, extraWork));
}

/** Every active component, including ones that still need a formula. */
export function listCatalogComponents(list, extraWork = null) {
  return prepareComponentRows(list, extraWork).filter((r) => r.is_active !== false);
}

/** Same visibility rules as the Salary Components hub (active + configured). */
export function filterComponentsForPipeline(list, extraWork = null) {
  const synced = prepareComponentRows(list, extraWork);
  return synced.filter(
    (r) =>
      isVariablePayrollComponent(r) ||
      (r.is_active !== false && formulaStatus(r)?.tone !== "missing"),
  );
}
